"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardContainer = BoardContainer;
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const PieceDragContext_1 = require("~/components/board/drag/PieceDragContext");
const BoardSurface_1 = require("./BoardSurface");
const overlays_1 = require("./overlays");
const useStyles = (0, react_jss_1.createUseStyles)({
    boardContainer: {
        flex: 1,
        position: "relative",
    },
});
function BoardContainer() {
    const styles = useStyles();
    return (react_1.default.createElement(PieceDragContext_1.PieceDragContextProvider, null,
        react_1.default.createElement("div", { className: styles.boardContainer },
            react_1.default.createElement(BoardSurface_1.BoardSurface, null,
                react_1.default.createElement(overlays_1.NowPlaying, null),
                react_1.default.createElement(overlays_1.ReadyOverlay, null),
                react_1.default.createElement(overlays_1.VictoryOverlay, null),
                react_1.default.createElement(overlays_1.MatchRewardsOverlay, null),
                react_1.default.createElement(overlays_1.ReconnectOverlay, null)))));
}
